module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.cacbc42b.svg";